<div class="filters">
    <ng-container *ngIf="loading && pageCount == null">
        <p id="loading">
            Laden...
        </p>
    </ng-container>
    <ng-container *ngIf="error != null">
        <p id="error">
            {{error}}
        </p>
    </ng-container>

    <ng-container *ngIf="pageCount != null">
        <ng-container *ngIf="pageCount > 1">
            <div class="btn-group" role="group" id="pagination-group">
                <button
                    type="button"
                    class="btn btn-sm btn-outline-primary pagination-button"
                    (click)="setPageIndex(0)"
                    [disabled]="pageIndex === 0 || loading"
                >
                    1
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-outline-primary pagination-button"
                    (click)="previousPage()"
                    [disabled]="!canPreviousPage() || loading"
                >
                    <fa-icon
                        [icon]="faAngleDoubleLeft"
                    >
                    </fa-icon>
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-outline-primary pagination-button"
                    (click)="nextPage()"
                    [disabled]="!canNextPage() || loading"
                >
                    <fa-icon
                            [icon]="faAngleDoubleRight"
                    >
                    </fa-icon>
                </button>
                <button
                    type="button"
                    class="btn btn-sm btn-outline-primary pagination-button"
                    (click)="setPageIndex(pageCount - 1)"
                    [disabled]=" pageIndex === pageCount - 1 || loading"
                >
                    {{pageCount}}
                </button>
            </div>
        </ng-container>

        <p class="text-muted" id="subtitle">
            Seite {{pageIndex + 1}} von {{pageCount}}.
        </p>

        <ng-container *ngFor="let filter of this.columnFilters; let i = index">
            <select class="form-control form-control-sm filter-select" [(ngModel)]="this.columnFilterValues[i]">
                <option *ngFor="let filterValue of this.columnFilters[i]" [selected]="filterValue === this.columnFilterValues[i]" [value]="filterValue">
                    <p>
                        {{columnFiltersDisplay[i](filterValue)}}
                    </p>
                </option>
            </select>
        </ng-container>

        <ng-container *ngIf="loading">
            <div class="spinner-border text-primary activity-accessory loading-spinner" id="loading-indicator">
                <span class="sr-only">Laden...</span>
            </div>
        </ng-container>

        <div class="flex-spacer">
        </div>

        <ng-container *ngIf="!disableFilter">
            <div class="input-group input-group-sm" id="filter-text-box">
                <div class="input-group-prepend">
                    <div class="input-group-text">
                        <fa-icon [icon]="faSearch"></fa-icon>
                    </div>
                </div>
                <input
                    class="form-control"
                    type="search"
                    [(ngModel)]="filter"
                    (ngModelChange)="filterChange.emit(filter)"
                    (search)="onSubmitFilter()"
                    [placeholder]="filterPlaceholder"
                >
            </div>
        </ng-container>
    </ng-container>
</div>
